// extracted by mini-css-extract-plugin
export default {"materialItem":"styles_materialItem__wbq5e"};